import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { Button } from '@/components/button'
import { openTwoFactorDialog } from '@/utils/twoFactorHelper'

const downloadPublicKeyColumnProps = ({ downloadPublicKey, localize }) => {
  class ActionButtonsCell extends GridCell {
    render () {
      const { invalidatedAt, id } = this.props.dataItem
      return (
        <td>
          {!invalidatedAt && <Button
            className='download-button'
            color='primary'
            onClick={() => openTwoFactorDialog(() => downloadPublicKey(id))}>{localize('Common.Download')}</Button>}
        </td>
      )
    }
  }
  return {
    sortable: false,
    filterable: false,
    cell: ActionButtonsCell
  }
}

const invalidateKeyColumnProps = ({ invalidateKey, localize }) => {
  class ActionButtonsCell extends GridCell {
    render () {
      const { invalidatedAt, id } = this.props.dataItem
      return (
        <td>
          {invalidatedAt === null && <Button
            className='invalidate-button'
            color='primary'
            confirmTitle='Common.Confirmation'
            confirmText='Common.AreYouSure'
            onClick={() => openTwoFactorDialog(() => invalidateKey(id))}>{localize('Security.Invalidate')}</Button>}
        </td>
      )
    }
  }
  return {
    sortable: false,
    filterable: false,
    cell: ActionButtonsCell
  }
}

const deleteKeyColumnProps = ({ deleteRsaKey, localize }) => {
  class ActionButtonsCell extends GridCell {
    render () {
      const { invalidatedAt, id } = this.props.dataItem
      return (
        <td>
          {invalidatedAt && <Button
            className='btn-icon delete-button'
            color='primary'
            confirmTitle='Common.Confirmation'
            confirmText='Common.AreYouSure'
            onClick={() => deleteRsaKey(id)}
            icon='x' />}
        </td>
      )
    }
  }
  return {
    sortable: false,
    filterable: false,
    cell: ActionButtonsCell
  }
}

export {
  downloadPublicKeyColumnProps,
  invalidateKeyColumnProps,
  deleteKeyColumnProps
}



// WEBPACK FOOTER //
// ./src/components/userProfile/rsaKeys/gridActions.js